import { render, staticRenderFns } from "./Ligacoes.vue?vue&type=template&id=e34b164c&scoped=true&"
import script from "./Ligacoes.vue?vue&type=script&lang=js&"
export * from "./Ligacoes.vue?vue&type=script&lang=js&"
import style0 from "./Ligacoes.vue?vue&type=style&index=0&id=e34b164c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34b164c",
  null
  
)

export default component.exports